// extracted by mini-css-extract-plugin
export default {"vmvDescription":"VMVDescription_vmvDescription__iVdfw","vmvDescription__container":"VMVDescription_vmvDescription__container__cyUzm"};